export { default as add } from "lodash/add"; // 加
export { default as subtract } from "lodash/subtract"; // 减
export { default as multiply } from "lodash/multiply"; // 乘
export { default as divide } from "lodash/divide"; // 除
